//# sourceMappingURL=style-definition.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/style-definition.interface.js
// module id = 1183
// module chunks = 4